import React from 'react';
import SectionHead from './SectionHead';
import { Reveal } from './reveal';
import { track } from '../lib/track';

const FINANCING_MESSAGE =
  "Hi, I'm interested in possibly financing one of your barges, could you please send me an application?";

function requestFinancingApplication() {
  track('buy_click', { location: 'financing' });
  window.dispatchEvent(
    new CustomEvent('prefill-quote-message', {
      detail: { message: FINANCING_MESSAGE, source: 'financing' },
    })
  );
}

export default function Financing() {
  return (
    <section
      id="financing"
      data-testid="financing-section"
      className="relative py-16 sm:py-20 lg:py-32 bg-black overflow-hidden border-t border-white/5"
    >
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="sr-only">
          <SectionHead eyebrow="Financing Available" titleLines={['Get Your New Barge Financed']} />
        </div>

        <Reveal delay={0.2}>
          <div className="panel rounded-xl p-6 sm:p-7 md:p-9 flex flex-col md:flex-row items-start md:items-center justify-between gap-5 md:gap-6">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="h-px w-8 sm:w-10 bg-cyan-400" />
                <span className="font-tech text-cyan-300 text-[11px] uppercase tracking-[0.32em]">
                  Financing Available
                </span>
              </div>
              <h3 className="font-display text-white text-lg sm:text-xl md:text-2xl font-semibold tracking-wide">
                Get Your New Barge Financed
              </h3>
              <p className="mt-2 text-zinc-400 text-sm md:text-base max-w-2xl">
                Barge financing and leasing options available for HDPE work barges, pneumatic pile drivers, and trailers — subject to application and lender approval. Request an application.
              </p>
            </div>
            <button
              type="button"
              onClick={requestFinancingApplication}
              data-testid="financing-request-application-btn"
              className="btn-teal px-5 sm:px-6 py-3 rounded-md text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-[0.18em] whitespace-nowrap"
            >
              Request an Application
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
